<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    document.title = this.$t('common.title');

    this.$store.dispatch('checkVersion');
  },
};
</script>
